import React from "react";

const GenericButton = ({onClick, text, cssClasses, disabled = false, hidden = false, testid = 'generic-button'}) => {
    return (
        <>
            <button type={"button"}
                    hidden={hidden}
                    disabled={disabled}
                    data-testid={testid}
                    className={`button-pay ${cssClasses} ${disabled && `disabled`}`}
                    onClick={() => onClick()}>
                {text}
            </button>
        </>
    );
};

export default GenericButton;
